import { requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const getAllSpecialities = user => apiClient.get(user, 'api/specialities')

export const getSpecialityYears = (speciality, user) => {
  return requestWithPromise(
    `/api/specialities/${speciality.id}/speciality-years`,
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json?.data) {
      return json.data
    }
  })
}
